import { cn } from '@/lib/utils';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@e2n/ui';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function OccurrenceCounter({
  value,
  onChange,
}: {
  value: number | 1;
  onChange: (value: number) => void;
}) {
  const { t } = useTranslation();

  return (
    <>
      <InputGroup className="h-10 bg-white border-neutrals-300 has-disabled:opacity-100">
        <InputGroupInput
          type="number"
          min={1}
          max={31}
          step={1}
          inputMode="numeric"
          value={value}
          onChange={(e) =>
            onChange(Math.min(31, Math.max(1, Number(e.target.value))))
          }
          className={cn(
            'border-0 text-center [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none',
            '[&::-webkit-outer-spin-button]:appearance-none focus-visible:ring-0',
          )}
        />
        <InputGroupAddon>
          <InputGroupButton
            size="icon-xs"
            aria-label={t('domain.termine.form.wiederholungsCounter.decrement')}
            disabled={value <= 1}
            onClick={() => onChange(Math.max(1, value - 1))}
            className="text-neutrals-900 hover:bg-transparent cursor-pointer">
            <FontAwesomeIcon icon={faMinus} className="size-3.5" aria-hidden />
          </InputGroupButton>
        </InputGroupAddon>
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            size="icon-xs"
            aria-label={t('domain.termine.form.wiederholungsCounter.increment')}
            disabled={value >= 31}
            onClick={() => onChange(Math.min(31, value + 1))}
            className="text-neutrals-900 hover:bg-transparent cursor-pointer">
            <FontAwesomeIcon icon={faPlus} className="size-3.5" aria-hidden />
          </InputGroupButton>
        </InputGroupAddon>
      </InputGroup>
    </>
  );
}
